import { Separator } from '@talentmesh/ui/components/separator';
import AtsIntegrationSection from './AtsIntegrations/AtsIntegrationSection';
import EmailIntegrationSection from './EmailIntegrations/EmailIntegrationSection';

const IntegrationsTab = () => {
    return (
        <div className="flex flex-col gap-10">
            <EmailIntegrationSection />
            <Separator />
            <AtsIntegrationSection />
        </div>
    );
};

export default IntegrationsTab;
